import { BrandProperty, createBrandProperty } from '../properties/brand-property';
import { ProductProperty, createProductProperty } from '../properties/product-property';
import AnalyticsEvent from './analytics-event';
import { IdAlgo } from '@bc/shared';

export class ProductQuickAddToCartEvent extends AnalyticsEvent {
  public readonly name = 'Product Quick Added to Cart';
  public properties: {
    product: ProductProperty;
    brand: BrandProperty;
    page: number;
    quantity: number;
    id_section?: string;
    id_algo?: IdAlgo;
    section_position?: number;
    // Surface attribution for the completed add-to-cart (PUR-3216), mirroring the
    // click events so the outcome can be tied back to the homepage/carousel it came from.
    component?: string;
    parent_component?: string;
  };

  constructor(
    product: ProductProperty,
    brand: BrandProperty,
    page: number,
    quantity: number,
    sectionId: string,
    idAlgo?: IdAlgo,
    sectionPosition?: number,
    component?: string,
    source?: string
  ) {
    super();
    this.properties = {
      page: page,
      product: createProductProperty(product),
      brand: createBrandProperty(brand),
      quantity: quantity,
      id_section: sectionId,
      id_algo: idAlgo,
      section_position: sectionPosition,
      component: component,
      parent_component: source,
    };
  }
}
